import { createDOMScheduler, SSRPayload, createWebNodeBuilder, rehydrate, HTML, SSRContext } from '@lukekaalim/act-web';
import { RenderSpace2 } from '@lukekaalim/act-backstage';
import { createThreeJSBuilder, render } from '@lukekaalim/act-three';
import { DebugReconciler } from '@lukekaalim/act-debug';

import { App } from './App';
import { h } from '@lukekaalim/act';
import { Background } from './components/Background';

const mainHydrate = async (ssrManifestElement: HTMLElement) => {
  const payload = JSON.parse(ssrManifestElement.innerText) as SSRPayload;

  const reconciler = new DebugReconciler(createDOMScheduler());

  const webSpace = new RenderSpace2(reconciler.tree, createWebNodeBuilder(document.body))
  const threeSpace = new RenderSpace2(reconciler.tree, createThreeJSBuilder());
  
  reconciler.thread.bus.render = 
    function render(delta) {
      webSpace.create(delta);
      threeSpace.create(delta);

      webSpace.update(delta);
      threeSpace.update(delta);
    }

  rehydrate({ Background }, reconciler, webSpace, payload);

  for (const root of payload.commits.filter(c => c.distance === 1).map(c => c.id))
    reconciler.tree.roots.add(root)
};
const mainSPA = () => {
  const scheduler = createDOMScheduler();
  const reconciler = new DebugReconciler(scheduler);

  const webSpace = new RenderSpace2(reconciler.tree, createWebNodeBuilder(document.body));
  const threeSpace = new RenderSpace2(reconciler.tree, createThreeJSBuilder());

  reconciler.bus = {
    render(delta) {
      webSpace.create(delta);
      threeSpace.create(delta);

      webSpace.update(delta);
      threeSpace.update(delta);
    },
  }

  const ssrContext: SSRContext = {
    components: new Map(),
    contexts: new Map(),
    commits: new Map(),
    commitIdRemap: new Map(),
    mounts: [],

    mode: 'client',
    contextCommitID: null,
    readyForServer() {}
  };
  
  reconciler.mount(h(HTML, {}, h(SSRContext.Provider, { value: ssrContext }, h(App))));
}

const main = async () => {
  const ssrManifestElement = document.getElementById('ssr-manifest')

  if (ssrManifestElement)
    mainHydrate(ssrManifestElement)
  else
    mainSPA()
}


main();